import { render, staticRenderFns } from "./SpcmListV1.vue?vue&type=template&id=72b21056&scoped=true"
import script from "./SpcmListV1.vue?vue&type=script&lang=js"
export * from "./SpcmListV1.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./SpcmListV1.vue?vue&type=style&index=1&id=72b21056&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b21056",
  null
  
)

export default component.exports